module.exports = __webpack_public_path__ + "img/swpfilter.562eff58.svg";